import React from 'react';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';

type PopoverButtonProps = {
  children: (options: {
    'aria-describedby'?: string;
    onClick: (event: React.MouseEvent) => void;
  }) => React.ReactNode;
  content: React.ReactNode;
  id: string;
};

const PopoverButton = ({ id, children, content }: PopoverButtonProps) => {
  const [anchorEl, setAnchorEl] = React.useState<Element | null>(null);

  const handleClick = (event: React.MouseEvent) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const handleClickAway = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popperId = open ? `popover-${id}` : undefined;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        {children({ 'aria-describedby': popperId, onClick: handleClick })}
        <Popper id={popperId} open={open} anchorEl={anchorEl}>
          {content}
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default PopoverButton;
